import mitt from 'mitt';

export class CancelableEvent {
    cancelled = false;

    cancel() {
        this.cancelled = true;
    }

    preventDefault() {
        this.cancelled = true;
    }
}




// Save a single instance so that IF there are multiple createApp() calls, they
// all share the same mitt instance.
/** @type {Emitter} */
let mittInstance;

/**
 * Attach global mitt() properties for Vue. The eventbus has
 * changed in Vue 3 and this is a workaround. We should
 * update our code to use the new eventbus syntax.
 *
 * @see https://vuejs.org/guide/components/events.html
 */
export default {
    install(app) {

        app.config.globalProperties.Bus = mittInstance ??= mitt();

        app.mixin({
            methods: {
                emit(event, data) {
                    this.Bus.emit(event, data);
                }
            }
        });

        //global emit shortcut
        window.emit = function(eventName, data) {
            return app.config.globalProperties.Bus.emit(eventName, data)
        };
    }
}
